"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Operator = void 0;
var tslib_1 = require("tslib");
var Node_1 = require("./Node");
/**
 * An Operator saves the state of a combined query
 */
var Operator = /** @class */ (function (_super) {
    tslib_1.__extends(Operator, _super);
    /**
     * @param entityManager The owning entity manager of this query
     * @param resultClass The query result class
     * @param operator The operator used to join the childes
     * @param childes The childes to join
     */
    function Operator(entityManager, resultClass, operator, childes) {
        var _this = _super.call(this, entityManager, resultClass) || this;
        _this.operator = operator;
        _this.childes = childes;
        return _this;
    }
    Operator.prototype.toJSON = function () {
        var json = {};
        json[this.operator] = this.childes;
        return json;
    };
    return Operator;
}(Node_1.Node));
exports.Operator = Operator;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3BlcmF0b3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJPcGVyYXRvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQ0EsK0JBQThCO0FBSTlCOztHQUVHO0FBQ0g7SUFBZ0Qsb0NBQU87SUFXckQ7Ozs7O09BS0c7SUFDSCxrQkFBWSxhQUE0QixFQUFFLFdBQXFCLEVBQUUsUUFBZ0IsRUFBRSxPQUFrQjtRQUFyRyxZQUNFLGtCQUFNLGFBQWEsRUFBRSxXQUFXLENBQUMsU0FHbEM7UUFGQyxLQUFJLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQztRQUN6QixLQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQzs7SUFDekIsQ0FBQztJQUVELHlCQUFNLEdBQU47UUFDRSxJQUFNLElBQUksR0FBc0MsRUFBRSxDQUFDO1FBQ25ELElBQUksQ0FBQyxJQUFJLENBQUMsUUFBUSxDQUFDLEdBQUcsSUFBSSxDQUFDLE9BQU8sQ0FBQztRQUNuQyxPQUFPLElBQUksQ0FBQztJQUNkLENBQUM7SUFDSCxlQUFDO0FBQUQsQ0FBQyxBQTVCRCxDQUFnRCxXQUFJLEdBNEJuRDtBQTVCWSw0QkFBUSJ9